<template>
    <div>
        <Steps :current-page="4"></Steps>
        <div class="text-center heading-wrapper">
            <span class="heading">{{ $t('choose_profile') }}</span>
        </div>
        <div class="container container-xs" v-if="!loading">
            <div class="purchase-wrapper">
                <div class="text-center">
                    <span class="main-text">{{ $t('order_step4') }}</span>
                </div>
            </div>
            <template v-if="!isLoggedIn">
                <div class="text-center">
                    <p class="p-first-login">
                        <router-link class="main-link" :to="{name: 'login', params: {from: 'billing'}}">
                            {{ $t('login_to_your_account') }}
                        </router-link>
                        {{ $t('login_to_your_account_2') }}
                    </p>
                </div>
                <div class="d-flex justify-content-center text-center" style="position: relative;">
                    <div class="circle">
                        <p class="text">{{ $t('or') }}</p>
                    </div>
                </div>
                <div class="text-center mb-5 mb-md-0">
                    <p class="p-first-login">
                        {{ $t('order_without_account') }}
                    </p>
                </div>

                <div class="container-billing">
                    <div class="alert alert-danger text-center" ref="warningMessage" v-if="showWarningMessageStatus">
                        {{ $t('fill_all_fields') }}
                    </div>
                    <div class="form-group">
                        <label for="email" class="input-text">{{ $t('label_email') }}*</label>
                        <span class="invalid-feedback">
                            {{errorMsgs.email}}
                        </span>
                        <input dusk="email-address" id="email" class="form-control p-4 mb-3" type="text" @input="validate" v-model="profileData.email" :class="{'has-error': errorMsgs.email}">
                        <div class="d-flex mb-4">
                            <div class="icon warning-icon mr-2"></div>
                            <p>{{ $t('order_address_info') }}</p>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="phone" class="input-text">{{ $t('label_phone') }}*</label>
                        <span class="invalid-feedback">
                            {{errorMsgs.phone}}
                        </span>
                        <input id="phone" class="form-control p-4" type="tel" @input="validate" v-model="profileData.phone" :class="{'has-error': errorMsgs.phone}">
                    </div>
                    <BillingProfile @verifiedStatus="setVerifiedStatus" @resetErrors="resetErrorMsgs" v-on:input="updateProfileFromComponent" :errorMsgs="errorMsgs"></BillingProfile>
                </div>
            </template>

            <template v-if="isLoggedIn">
                <div class="profiles" v-if="profiles">
                    <div v-for="profile in profiles" :key="profile.id" class="profile" :class="{'danger': !isValidatedProfile(profile), 'active': orderDetails.profile_id == profile.id}" @click="doSetDefaultProfile(profile)">
                        <Profile :profile="profile"></Profile>
                        <div class="bullet" v-if="orderDetails.profile_id == profile.id">
                            <span class="icon v-icon"></span>
                        </div>
                        <div class="profile-actions">
                            <router-link :to="{name: 'edit-profile', params: {id: profile.id}}" class="icon-wrapper edit">
                                <div class="icon edit-icon"></div>
                            </router-link>
                            <div class="delete icon-wrapper" @click.stop="deleteProfileAsk(profile.id)">
                                <div class="icon delete-icon"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-md-end">
                    <router-link :to="{name: 'add-profile'}" class="add-profile main-btn">
                        {{ $t('billing_add_new_profile') }}
                        <span class="icon icon-plus"></span>
                    </router-link>
                </div>
            </template>
            <BillingButtons @nextStepAttempt="showWarningMessage()" :hasCompletedBillingFields="valid" :orderDetails="orderDetails"></BillingButtons>
        </div>
    </div>
</template>

<script>

import BillingButtons from './BillingButtons.vue'
import BillingProfile from './../snippets/BillingProfile.vue'
import { mapGetters, mapActions, mapState } from 'vuex'
import Steps from '../snippets/Steps.vue'
import Profile from '../account/Profile.vue'

export default {
    name: 'Billing',
    data: function() {
        return {
            loading: true,
            setDefaultProfileClickThrottling: false,
            hasCompletedBillingFields: false,
            valid: false,
            profileData: {
                email: '',
                phone: ''
            },
            profileTmp: {},

            errorMsgs: {
                first_name: '',
                last_name: '',
                address: '',
                country: '',
                county: '',
                company: '',
                j_code: '',
                fiscal_code: '',
                email: '',
                phone: '',
                city: ''
            },

            showWarningMessageStatus: false
        }
    },
    computed: {
        ...mapGetters({
            isLoggedIn: 'auth/getLoginStatus',
            tmpProfile: 'profiles/getTmpProfile'
        }),

        ...mapState('countries', [
            'countries'
        ]),

        ...mapState('profiles', [
            'profiles'
        ]),

        ...mapState('cart', [
            'orderDetails'
        ])
    },
    components: {
        BillingButtons,
        BillingProfile,
        Steps,
        Profile
    },
    props: {
    },
    mounted() {
        if(this.isLoggedIn) {
            this.hasCompletedBillingFields = true;
        }

        this.validate();
        this.getCountries();
        this.init();
    },
    methods: {

        async init() {

            if(this.$store.getters['auth/getLoginStatus']) {

                await this.getProfiles();

                if(!this.profiles) {
                    this.$router.push({name : 'add-profile'});
                }
                else if(!this.orderDetails.profile_id){ //setting default profile id or the first one
                    for(let i = 0; i < this.profiles.length; i++) {
                        if(this.profiles[i].is_default) {
                            this.setProfileId(this.profiles[i].id);
                        }
                    }

                    if(!this.orderDetails.profile_id) {
                        this.setProfileId(this.profiles[0].id);
                    }

                    this.valid = true;
                }
            }
            else {
                if(this.tmpProfile) {
                    this.profileData.email = this.tmpProfile.email;
                    this.profileData.phone = this.tmpProfile.phone;
                }
            }

            this.loading = false;
        },

        ...mapActions('countries', [
            'getCountries'
        ]),

        ...mapActions('cart', [
            'setProfileId'
        ]),

        ...mapActions({
            updateTmpProfile: 'profiles/updateTmpProfile'
        }),

        ...mapGetters('cart', [
            'cartCount'
        ]),

        ...mapActions('profiles', [
            'getProfiles',
            'setDefaultProfile'
        ]),

        updateProfileFromComponent(data) {
            this.profileTmp = data.profile;
            this.validate();
        },

        doSetDefaultProfile(profile) {
            if(!this.isValidatedProfile(profile)) {
                this.$dialog.alert({
                    'message': this.$t('invalid_profile_msg'),
                    'confirmButtonText': this.$t('btn_i_understand')
                });

                return false;
            }

            this.setProfileId(profile.id);
            this.validate();
        },

        deleteProfileAsk(id) {
            this.delete_profile_id = id;

            this.$dialog.confirm({
                title: this.$t('delete_profile_msg'),
                message: this.$t('delete_profile_confirm'),
                cancelButtonText: this.$t('no'),
                confirmButtonText: this.$t('yes'),
                beforeClose: this.removeProfile
            })
            .catch(() => {
                // on cancel
            });
        },

        removeProfile(action, done) {
            if(action == 'confirm') {
                this.$axios.delete('/profiles/' + this.delete_profile_id).then(async response => {

                    if(this.orderDetails.profile_id == this.delete_profile_id) {
                        this.setProfileId(0);
                    }
                    await this.init();
                    done();
                }).catch(err => {
                    if(err.response) {
                        this.$dialog.alert({
                            'message': err.response.data.error.error_msg,
                            'confirmButtonText': this.$t('btn_i_understand')
                        });
                    }
                    done();
                });
            }
            else {
                done();
            }
        },

        setVerifiedStatus(status) {
            this.hasCompletedBillingFields = status;
            this.validate();
        },

        validate() {

            if(!this.isLoggedIn) {

                if(
                    this.hasCompletedBillingFields && 
                    this.isEmailValid(this.profileData.email) && 
                    (this.profileData.phone.match(/^(\d{10})$/) || (this.profileData.phone.length && this.profileTmp.country != 1))
                ) {
                    this.valid = true;
                }
                else {
                    this.valid = false;
                }

                if(this.valid) {
                    let profile = {...this.profileTmp};
                    profile.email = this.profileData.email;
                    profile.phone = this.profileData.phone;
                    this.updateTmpProfile({'profile': profile});
                }
            }
            else {
                if(this.orderDetails.profile_id) {
                    this.valid = true;
                }
                else {
                    this.valid = false;
                }
            }

            this.$emit('verifiedStatus', this.valid);
        },

        showWarningMessage() {
            this.showWarningMessageStatus = true;

            this.validateForm();

            this.$nextTick(() => {
                if(this.showWarningMessageStatus) {
                    this.$refs.warningMessage.scrollIntoView(false);
                }
            });
        },

        resetErrorMsgs() {
            this.errorMsgs = {
                first_name: '',
                last_name: '',
                address: '',
                country: '',
                county: '',
                company: '',
                j_code: '',
                fiscal_code: '',
                email: '',
                phone: '',
                city: ''
            };
        },

        validateForm() {
            this.resetErrorMsgs();

            Object.keys(this.profileData).forEach(k => {
                if (typeof this.profileData[k] == 'string') {
                    this.profileData[k] = this.profileData[k].trim();
                }
            });
            Object.keys(this.profileTmp).forEach((k) => {
                if (typeof this.profileTmp[k] == 'string') {
                    this.profileTmp[k] = this.profileTmp[k].trim();
                }
            });

            if(!this.isEmailValid(this.profileData.email)) {
                this.errorMsgs.email = this.$t('invalid_email');
            }

            if(!this.profileData.phone.match(/^(\d{10})$/) && this.profileTmp.country == 1) {
                this.errorMsgs.phone = this.$t('invalid_tel');
            }

            if(!this.profileData.phone.length) {
                this.errorMsgs.phone = this.$t('invalid_tel');
            }

            if(!this.profileTmp.city.length) {
                this.errorMsgs.city = this.$t('mandatory_city');
            }

            if(this.profileTmp.billing_type == 'pf') {
                if(!this.profileTmp.last_name.length) {
                    this.errorMsgs.last_name = this.$t('mandatory_first_name');
                }

                if(!this.profileTmp.first_name.length) {
                    this.errorMsgs.first_name = this.$t('mandatory_last_name');
                }

                if(!(this.profileTmp.county > 0)) {
                    this.errorMsgs.county = this.$t('mandatory_country');
                }
            }
            else {
                if(!this.profileTmp.fiscal_code.length) {
                    this.errorMsgs.fiscal_code = this.$t('mandatory_fiscal_code');
                }

                if(!this.profileTmp.j_code.length) {
                    this.errorMsgs.j_code = this.$t('mandatory_j_code');
                }

                if(!this.profileTmp.company.length) {
                    this.errorMsgs.company = this.$t('mandatory_company');
                }

                if(!this.profileTmp.address.length) {
                    this.errorMsgs.address = this.$t('mandatory_address');
                }
            }

            this.showWarningMessageStatus = false;
            Object.keys(this.errorMsgs).forEach(key => {
                if(this.errorMsgs[key].length) {
                    this.showWarningMessageStatus = true;
                }
            })
        }
    }
};



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/scss/_variables';

    $lightgrey: lightgrey;
    $green: #59af54;
    $light-grey: #D6D6D6;

    .heading-wrapper {
        margin-top: 30px;

        .heading {
            color: $black;
        }
    }

    .purchase-wrapper{
        margin-top: 14px;

        h1 {

            font-weight: 900;
            font-size: 54px;
            margin-top: 87px;
        }
    }

    .form-control{
        width: 70% !important;
    }
    .p-first-login{

        font-weight: bold;
        font-size: 22px;
        margin-bottom: 0;
    }

    .main-link {
        font-size: 22px;
        font-weight: bold;
    }
    .circle {
        width: 75px;
        height: 75px;
        border-radius: 50%;
        background-color: #0F2443;
        margin: 40px 0;
    }
    .text {
        font-size: 18px;
        font-weight: bold;
        color: white;
        text-align: center;
        padding-top: 24.5px;
    }
    .input-text{

        font-size: 18px;
        font-weight: 500;
    }
    .container-billing{
        background-color: #FFFEFD;
        padding: 50px;
    }

    .profiles {
        padding-top: 10px;
        padding-bottom: 20px;

        .profile {
            border: 1px solid $black;
            border-radius: 4px;
            padding: 21px 24px;
            margin: 13px 0px;
            position: relative;
            cursor: pointer;
            background: $profile-color;

            &.active {
                border: 3px solid $black;
                padding: 19px 22px;
            }

            &:not(:last-child) {
                margin-bottom: 40px;
            }

            &.danger {
                border-color: #F8BDB8;
            }

            .bullet {
                width: 30px;
                height: 30px;
                background: $black;
                position: absolute;
                top: -10px;
                right: -5px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .profile-type {
                font-size: 12px;
                color: $light-grey;
            }

            .profile-name {
                color: $black;
                font-weight: bold;
                font-size: 22px;
            }

            .fiscal-or-address {
            }

            .profile-actions {
                display: flex;
                justify-content: flex-end;
                margin-top: 15px;

                .edit {
                    margin-right: 27px;
                }

                .icon-wrapper {
                    @media only screen and (max-width: 768px) {
                        background: white;
                        width: 40px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                    }
                }
            }


            .btn-Termene {
                border: 1px solid #54AD32;
                color: #54AD32;

                @media only screen and (max-width: 768px) {
                    width: 100%;
                }
            }
        }

    }

    .add-profile {
        max-width: 400px;
    }

    @media only screen and (max-width: 767px) {
        .container-billing{
            background-color: #FFFEFD;
            padding: 30px 20px;
            margin: 0px -20px;
        }
        .p-first-login{
            font-size: 24px !important;
        }
        .form-control{
            width: 100% !important;
        }
    }

</style>
